import { render, staticRenderFns } from "./autoCtl.vue?vue&type=template&id=1af50a0a&scoped=true&"
import script from "./autoCtl.vue?vue&type=script&lang=js&"
export * from "./autoCtl.vue?vue&type=script&lang=js&"
import style0 from "./autoCtl.vue?vue&type=style&index=0&id=1af50a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af50a0a",
  null
  
)

export default component.exports